import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Button,
  Collapse,
  FormGroup,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import FiltersResetButton from './FiltersResetButton';

import { getMatchingSearches } from '../../helpers/Search';
import { getUserSetting } from '../../helpers/Settings';
import { prepareSearchFilters } from '../../helpers/URLParams';

const FiltersPinnedSearches = ({
  handleReset,
  handleChangeFilters,
  selectedFilters,
  type,
}) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(false);

  const pinnedSearches = getUserSetting('pinned_searches') ?
    getUserSetting('pinned_searches').filter(s => s.type === type) : [];
  const matchingSearches = getMatchingSearches(selectedFilters, type);

  const prevMatchingSearches = useRef();

  const handleFilters = (filters) => {
    const newFilters = prepareSearchFilters(filters);
    handleReset();
    handleChangeFilters(newFilters);
  };

  useEffect(() => {
    if (!_.isEqual(prevMatchingSearches.current, matchingSearches)) {
      if (matchingSearches.length > 0) {
        setIsOpen(true);
      }
    }

    prevMatchingSearches.current = matchingSearches;
  }, [matchingSearches]);

  return (
    <div className="files-filter pinned-searches-filter">
      <div className="filter-header">
        <Button onClick={() => setIsOpen(!isOpen)} className="filter-title">
          <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
          <span>{intl.formatMessage({ defaultMessage: 'Pinned searches' })}</span>
          {' '}
          {matchingSearches.length > 0 && (
            <div className="pinned-search-filter-badge" />
          )}
        </Button>
        {matchingSearches.length > 0 && (
          <FiltersResetButton
            handleReset={handleReset}
          />
        )}
      </div>
      <Collapse
        isOpen={isOpen}
        className="filter-body"
      >
        <div className="pinned-searches-filter-collapse filter-form">
          {pinnedSearches.length === 0 && (
            <p className="no-pinned-searches">
              {intl.formatMessage({
                defaultMessage: 'No pinned searches found. Search and/or select filters to create a pinned search.',
              })}
            </p>
          )}
          {pinnedSearches.length > 0 && (
            <ul>
              {pinnedSearches.map((s, idx) => {
                const isMatching = matchingSearches.find(m => {
                  const mFilters = m.filters.map(sf => ({ key: sf.key, type: sf.type }));
                  const sFilters = s.filters.map(sf => ({ key: sf.key, type: sf.type }));

                  return _.isEqual(mFilters, sFilters);
                });
                return (
                  <FormGroup key={s.uuid}>
                    <li
                      className={classnames({ 'pinned-search-matching': isMatching })}
                    >
                      {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                      {/* eslint-disable jsx-a11y/no-static-element-interactions */}
                      <span
                        id={`TagSearchFilterMatching-${idx}`}
                        className="pinned-search-icon"
                      >
                        <i
                          className="far fa-thumbtack fa-rotate-by"
                          style={{ '--fa-rotate-angle': '45deg' }}
                        />
                      </span>
                      <Label
                        className="pinned-search-name"
                        onClick={() => handleFilters(s.filters)}
                      >
                        {s.name}
                        {isMatching && (
                          <div className="pinned-search-filter-badge" />
                        )}
                      </Label>
                      {/* eslint-enable jsx-a11y/no-static-element-interactions */}
                      {/* eslint-enable jsx-a11y/click-events-have-key-events */}
                    </li>
                  </FormGroup>
                );
              })}
            </ul>
          )}
        </div>
      </Collapse>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

FiltersPinnedSearches.propTypes = {
  handleReset: PropTypes.func.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(FiltersPinnedSearches);
